<template>
  <div>
    <q-table
      flat
      dense  
      virtual-scroll
      hide-pagination
      row-key="PRT_ID"
      style="overflow-x: auto;"
      :fullscreen="isFullscreen"      
      :no-data-label="$t('erro.semDados')"
      :rows="filteredData"
      :rows-per-page-options="[0]"
      :columns="table_columns"
      :style="isFullscreen ? 'width: 100%; height: 100%;' : ''"
      class="dass-sticky-header-table dass-table-border q-mb-sm"
      @virtual-scroll="onTableScroll"
    >
      <template v-slot:top>
        <div class="col-12 flex justify-between">
          <h3>{{ $t('dass.statementWithTransactionsCarriedOut') }}</h3>
          <q-btn
            dense
            flat
            icon="mdi-fullscreen"            
            id="dass-btn-fullscreen"
            @click="() => {
              this.isFullscreen = !this.isFullscreen
            }"
          />
        </div> 
        <div class="col-12 flex justify-between">
          <div  class="col-3">
            <span  style="color: blue">{{`Filtros selecionados` + ': ' + this.selectedFilters.length}}</span>
            <q-btn
              dense
              tooltip="Limpar filtros"
              icon="mdi-filter-remove-outline"              
              :class="`q-ml-md q-mr-sm dass-color-button-wallet-table-${brandName}`"
              @click="clearFilterColumn"
            />
          </div>
          <div class="col-6 flex q-gutter-md ml-auto"> 
            <q-input
              v-if="isFilterDateMoviment"
              dense
              debounce="400"
              type="date"
              :label="$t('dass.dateOfMovementFrom')"
              v-model="dt_inicial"
              class="dass-inputs-filter-table-transactions"
              @keyup.enter="loadFilter('MOV_DATA')"
            >
              <template v-slot:append>
              </template>
            </q-input>         
            <q-input
              v-if="isFilterDateMoviment"
              dense
              debounce="400"
              type="date"
              :label="$t('dass.moveDateby')"
              v-model="dt_final"
              class="dass-inputs-filter-table-transactions"
              @keyup.enter="loadFilter('MOV_DATA')"
            >
              <template v-slot:append>
              </template>
            </q-input>
            <q-btn v-if="isFilterDateMoviment" :loading="this.isLoadingFilter" round dense flat icon="mdi-magnify" :class="`dass-color-button-wallet-table-${brandName}`" @click="loadFilter('MOV_DATA')" />
            <q-btn v-if="isFilterDateMoviment"  round dense flat icon="mdi-magnify-remove-outline" :class="`dass-color-button-wallet-table-${brandName}`" @click="clearFilter" />
            <q-input
              v-if="isFilterOrder"
              dense
              type="text"
              debounce="400"
              label="Pedido"
              v-model="ped_codigo"
              class="dass-inputs-filter-table-transactions"
              @keyup.enter="loadFilter('PED_CODIGO')"
            >
              <template v-slot:append>
                <q-btn :loading="this.isLoadingFilter" @click="loadFilter('PED_CODIGO')" round dense flat icon="mdi-magnify" :class="`dass-color-button-wallet-table-${brandName}`"/>
                <q-btn  @click="clearFilter" round dense flat icon="mdi-magnify-remove-outline" :class="`dass-color-button-wallet-table-${brandName}`"/>
              </template>
            </q-input>
            <q-input
              v-if="isFilterProtocol"
              type="text"
              dense
              debounce="400"
              label="Protocolo"
              v-model="prt_id"
              class="dass-inputs-filter-table-transactions"
              @keyup.enter="loadFilter('PRT_ID')"
            >
              <template v-slot:append>
                <q-btn  :loading="this.isLoadingFilter" @click="loadFilter('PRT_ID')" round dense flat icon="mdi-magnify"  :class="`dass-color-button-wallet-table-${brandName}`"/>
                <q-btn  @click="clearFilter" round dense flat icon="mdi-magnify-remove-outline"  :class="`dass-color-button-wallet-table-${brandName}`"/>
              </template>
            </q-input>
            <q-btn-dropdown
              dropdown-icon="mdi-filter-menu-outline"
              :class="`q-ml-md q-mr-sm dass-color-button-wallet-table-${brandName}`"
            >
              <q-list>
                <q-item clickable v-close-popup @click="onItemClick('MOV_DATA')">
                  <q-item-section>
                    <q-item-label>{{$t('dass.dateOfMovement')}}</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable v-close-popup @click="onItemClick('PED_CODIGO')">
                  <q-item-section>
                    <q-item-label>{{ $t('home.pedido') }}</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable v-close-popup @click="onItemClick('PRT_ID')">
                  <q-item-section>
                    <q-item-label>{{ $t('protocolo.protocolo') }}</q-item-label>
                  </q-item-section>
                </q-item>                
              </q-list>
            </q-btn-dropdown>
          </div>
        </div>

      </template>
      <template v-slot:header-cell="props">
        <q-th class="dass-th-header" :class="{'dass-th-padding': !this.isRotated[props.col.field]}" :props="props">
          {{props.col.label}} 
           <div v-if="props.col.field == 'selected'">
            <q-checkbox dense v-model="valueCheckAll" @click="onCheckAll"/>
            <q-tooltip
              anchor="top middle"
              self="bottom middle"
              :label="!valueCheckAll ? $t('dassCheckAll') : $t('dassUncheckAll')"
            />
          </div>         
          <q-btn
            v-if="props.col.field !== 'selected'"
            icon="mdi-filter-menu-outline"
            :dense="true"
            size="0.6rem"
            :class="{ 'dass-rotated-button': this.isRotated[props.col.field],  'dass-rotated-button-back': !this.isRotated[props.col.field]}, `dass-color-button-wallet-table-${brandName}`"
            class="q-ml-md q-mr-sm"
            @click="toggleSelectFilter(props.col.field)"
          >
          </q-btn>
          <div v-show="showSelectFilter[props.col.field]" class="dass-filter-select q-ma-xs">
            <q-select
              v-model="filters[props.col.field]"
              :options="getUniqueOptions(props.col.field)"
              :label="props.col.label" 
              :class="`dass-select-filter-table-${brandName}`"             
              dense
              outlined
              multiple
              cleareble
              emit-value
              map-options
              hide-selected
              @update:model-value="selectFilter"
            >
              <template  #option="scope">
                <div class="column q-pr-sm" v-bind="scope.itemProps">
                  <q-item-section>
                    <q-checkbox
                      :model-value="scope.selected"
                      @update:model-value="scope.toggleOption(scope.opt)"
                    >
                      {{ scope.opt.label }}
                    </q-checkbox>
                  </q-item-section>
                </div>
              </template>
            </q-select>
          </div>
        </q-th>
      </template>
      <template v-slot:body="props">
        <q-tr>          
          <q-td key="MOV_DATA" class="dass-font-body-table dass-cell-value text-left">{{ props.row.MOV_DATA }}</q-td>
          <q-td key="DESC_OPER" class="dass-font-body-table dass-cell-value text-center">{{ props.row.DESC_OPER }}</q-td>
          <q-td key="PED_CODIGO" class="dass-font-body-table dass-cell-value text-center">{{ props.row.PED_CODIGO }}</q-td>
          <q-td key="PAG_DESCRICAO" class="dass-font-body-table dass-cell-value text-right">{{ props.row.PAG_DESCRICAO }}</q-td>
          <q-td key="PRT_ID" class="dass-font-body-table dass-cell-value text-center">{{ props.row.PRT_ID }}</q-td>
          <q-td key="TRANS_OPER" class="dass-font-body-table dass-cell-value text-center">{{ props.row.TRANS_OPER == 'Debit' ? 'Débito' : 'Crédito' }}</q-td>
          <q-td key="VALUE" :style="props.row.TRANS_OPER.startsWith('D') ? 'color: red' : 'color: #34C759'" class="dass-font-body-table dass-cell-value text-center">{{ formatedFields(props.row.TRANS_OPER, props.row.MOV_TIPO_LAN, props.row.VALUE)  }}</q-td>         
          <q-td key="SALDO_TOTAL" style="color: #34C759;" class="dass-font-body-table dass-cell-value text-center">{{ 'R$ '+ props.row.SALDO_TOTAL }}</q-td>          
        </q-tr>        
      </template>
    </q-table>
    <div v-if="dataTable.length <= 0 && isFiltered">
      <div class="dass-no-users-found">
        <div>
          <span style="width: 100%; margin-top: 10px;">
            {{$t('dassNoRecordsFoundOnThisPage')}}
          </span>
        </div>
        <div>
          <span style="width: 100%; margin-top: 10px;">
            {{$t('dassTryUsingAdvancedFiltersToDoAFullDatabaseSearch')}}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import { useIsSafari } from '@/composables/useIsSafari'
export default {
  name: 'StatementWithTransactionsCarriedOut',
   setup() {
    const { isSafari, brandName } = useIsSafari()    
    return {      
      isSafari,
      brandName
    }     
  },
  data() {
    return {
      current_list: [],      
      selectedFilters: [],
      isLoadingExport: false,
      isFilterDateMoviment: false,
      dt_inicial: '',
      dt_final: '',
      ped_codigo: '',
      prt_id: '',
      isFilterOrder: false,
      isFilterProtocol: false,
      isFilterDateRequestedIn: false,
      isFullscreen: false,
      isLoadingFilter: false,
      isRotated: {},
      showSelectFilter: {},
      filters: {
        MOV_DATA: [],
        DESC_OPER: [],
        PED_CODIGO: [],
        PAG_DESCRICAO: [],
        PRT_ID: [],
        VALUE: [],       
        TRANS_OPER: [],
        SALDO_TOTAL: [],
      }
    }
  },
  methods: {
    ...mapActions('wallet', ['listWalletHistoric']),
    ...mapActions('create_protocol', ['loadDataConsumer',]),
    getUniqueOptions(field) {
      const uniqueValues = [...new Set(this.filteredData.map(row => row[field]))]

      return uniqueValues.map(val => {
        let label = val;
        
        if (field === 'TRANS_OPER') {
          label = val === 'Debit' ? 'Débito' : 'Crédito';
        } else if (field === 'SALDO_TOTAL' || field === 'VALUE') {
          label = 'R$ ' + val;
        }

        return { label: label, value: val };
      });
    },   
    async loadConId() {
      if (!this.getDataConsumer?.length){ 
        await this.loadDataConsumer()
      }
    },
    formatedFields(mov_dbcd, mov_tipo_lan, value) {      
      return mov_dbcd == 'Debit' && mov_tipo_lan == 'V' ? '- R$ ' + value : mov_tipo_lan == 'B' && mov_dbcd == 'Debit' ? '- ' + value + ' %':
        mov_dbcd == 'Credit' && mov_tipo_lan == 'V' ? 'R$ ' + value : mov_dbcd == 'Credit' && mov_tipo_lan == 'B' ? value + ' %' : '' 
    },
    toggleSelectFilter(columnField) {
      this.isRotated[columnField] = !this.isRotated[columnField]
      this.showSelectFilter[columnField] = !this.showSelectFilter[columnField]
    },
    selectFilter(val) {
      if(val.length > 0) {
        this.selectedFilters.push(val)
      } else if(this.selectedFilters.length > 0 && val.length == 0) {
        this.selectedFilters.pop()
      }
    },
    async loadFilter(field) {
      const filter = field?.toLowerCase() || ''
      if(!filter) return
      const filterValue = this[field.toLowerCase()]
      this.isLoadingFilter = true
      
      if(filter == 'mov_data') {        
        await this.listWalletHistoric({ con_id: this.CON_ID, dt_inicial: this.dt_inicial ? this.$filters.toDateBRL(this.dt_inicial, 'yyyy-MM-DD') : '', dt_final: this.dt_final ? this.$filters.toDateBRL(this.dt_final, 'yyyy-MM-DD') : ''})
      } else {
        await this.listWalletHistoric({ con_id: this.CON_ID, [filter]: filterValue })
      }
      this.isLoadingFilter = false
    },
    clearFilter() {
      for (const prop in this.filters) {
        this.filters[prop] = []
      }
      this.isRotated = []
      this.showSelectFilter = []
      this.selectedFilters = []    
      this.isLoadingFilter = false
      this.dt_inicial = ''
      this.dt_final = ''
      this.ped_codigo = ''
      this.prt_id = ''  
    },
    clearFilterColumn() {
      for (const prop in this.filters) {
        this.filters[prop] = []
      }
      this.isRotated = []
      this.showSelectFilter = []
      this.selectedFilters = []      
    },
    moveSortIcons() {
      const headers = document.querySelectorAll('.dass-th-header')
      headers.forEach((header) => {
        const sortIcon = header.querySelector('.q-table__sort-icon')
        const dassSelect = header.querySelector('.dass-filter-select')

        if (sortIcon && dassSelect) {
          header.insertBefore(sortIcon, dassSelect)
        }
      })
    },
    onItemClick(isShowInputName) {
      return isShowInputName == 'MOV_DATA' ? this.isFilterDateMoviment = !this.isFilterDateMoviment :
        isShowInputName == 'PED_CODIGO' ? this.isFilterOrder = !this.isFilterOrder :
          isShowInputName == 'PRT_ID' ? this.isFilterProtocol = !this.isFilterProtocol : null
    }
  },
  computed: {
    ...mapGetters('create_protocol', ['getDataConsumer']),
    ...mapGetters('wallet', {
      dataTable: 'getWalletHistoric',
    }),  
    filteredData() {      
      let filtered = this.dataTable.filter(row => {
        return Object.keys(this.filters).every(key => {
          if(this.filters[key].length === 0) return true
          return this.filters[key].includes(row[key])
        })
      });
     
      filtered.sort((a, b) => {
        const parseDate = (dataStr) => {
          if (!dataStr) return 0;
          const [data, hora] = dataStr.split(' ');
          const [dia, mes, ano] = data.split('/');
          return new Date(`${ano}-${mes}-${dia}T${hora}`).getTime();
        };

        const timeA = parseDate(a.MOV_DATA);
        const timeB = parseDate(b.MOV_DATA);
        
        if (timeA !== timeB) {
          return timeA - timeB; 
        }        
        if (a.TRANS_OPER !== b.TRANS_OPER) {
          return a.TRANS_OPER === 'Credit' ? -1 : 1;
        }
        if (a.TRANS_OPER === 'Debit') {          
          return b.SALDO_TOTAL - a.SALDO_TOTAL; 
        } else {      
          return a.SALDO_TOTAL - b.SALDO_TOTAL; 
        }
      });

      
      return filtered.reverse();
    },
    table_columns: function () {
      return [
        {
          name: 'MOV_DATA',
          align: 'center',
          label: 'Data de movimento',
          field: 'MOV_DATA',
          sortable: true,
          classes: 'dass-cell-table',         
          headerClasses: `dass-header-table dass-header-table-${this.brandName}`
        },
        {
          name: 'DESC_OPER',
          align: 'center',
          label: 'Histórico',
          field: 'DESC_OPER',
          sortable: true,
          classes: 'dass-cell-table',          
          headerClasses: `dass-header-table dass-header-table-${this.brandName}`
        },
        {
          name: 'PED_CODIGO',
          align: 'center',
          label: 'Pedido',  
          field: 'PED_CODIGO',
          sortable: true,
          classes: 'dass-cell-table',         
          headerClasses: `dass-header-table dass-header-table-${this.brandName}`
        },
        {
          name: 'PAG_DESCRICAO',
          align: 'center',
          label: 'Tipo de pagamento',
          field: 'PAG_DESCRICAO',
          sortable: true,
          classes: 'dass-cell-table',         
          headerClasses: `dass-header-table dass-header-table-${this.brandName}`
        },
        {
          name: 'PRT_ID',
          align: 'center',
          label: 'Protocolo',
          field: 'PRT_ID',
          sortable: true,
          classes: 'dass-cell-table',         
          headerClasses: `dass-header-table dass-header-table-${this.brandName}`
        },
        {
          name: 'TRANS_OPER',
          align: 'center',
          label: 'Crédito/Débito',
          field: 'TRANS_OPER',
          sortable: true,
          classes: 'dass-cell-table',         
          headerClasses: `dass-header-table dass-header-table-${this.brandName}`
        },
        {
          name: 'VALUE',
          align: 'center',
          label: 'Vale compras',
          field: 'VALUE',
          sortable: true,
          classes: 'dass-cell-table',         
          headerClasses: `dass-header-table dass-header-table-${this.brandName}`
        },       
        {
          name: 'SALDO_TOTAL',
          align: 'center',
          label: 'Saldo Disponível',
          field: 'SALDO_TOTAL',
          sortable: true,
          classes: 'dass-cell-table',         
          headerClasses: `dass-header-table dass-header-table-${this.brandName}`
        },
        
        
      ]
    },    
  }, 
  async mounted() {
    this.moveSortIcons()
    await this.loadConId()
    this.CON_ID = this.getDataConsumer[0]?.CON_ID || 0
  }

}

</script>

<style lang="scss" scoped>
.dass-cell-value {
  width: auto;
  white-space: nowrap
}
.q-table__card {
  border-radius: var(--border-radius-card) !important;
  text-transform: uppercase;
}
thead tr {
  background-color: var(--color-default-new-balance) !important;
  color: white;
  font-weight: 700;
  height: 48px !important;     
}
#dass-btn-fullscreen {
  position: absolute;
  top: 0.2rem;
  right: 0.2rem;  
}
.dass-select-filter-table-umbro {
  background-color: white !important; 
  border-radius: var(--border-radius-card);
  color: var(--theme-white);
}
.dass-select-filter-table-newbalance {
  background-color: white !important; 
  border-radius: var(--border-radius-card);
  color: var(--theme-white);
}
.dass-select-filter-table-fila {
    background-color: white;
    border-color: white;
    border-radius: var(--border-radius-card);
    color: var(--color-fila-secondary);
}
.dass-header-table-umbro {
  font-family: Inter, sans-serif !important;
  text-transform: uppercase !important;
  color: white;
  background-color: var(--color-default-umbro) !important;
}
.dass-header-table-fila {
  font-family: Inter, sans-serif !important;
  text-transform: uppercase !important;
  color: white;
  background-color: var(--color-fila-secondary) !important;
}
.dass-header-table-newbalance {
  font-family: Inter, sans-serif !important;
  text-transform: uppercase !important;
  color: white !important;
  background-color: var(--color-default-new-balance) !important;
}
.dass-color-button-wallet-table-umbro {
  color: var(--theme-white) !important;
  background-color: var(--color-default-umbro) !important;
  border-radius: var(--border-radius-button-umbro) !important;  
}
.dass-color-button-wallet-table-fila {
  color: var(--theme-white) !important;
  background-color: var(--color-fila-primary) !important;
  border-radius: var(--border-radius-button-fila) !important; 
  padding-left: 0.7rem !important;
  padding-right: 0.7rem !important;
}
.dass-color-button-wallet-table-newbalance {
  color: var(--theme-white) !important;
  background-color: var(--color-default-new-balance) !important;
  border-radius: var(--border-radius-button-newbalance) !important; 
}
.dass-div-loading {
  width: 100%;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dass-no-users-found {
  width: 100%;
  margin-top: 15vh;
  margin-bottom: 15vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  justify-items: center;
}
.dass-font-header-table {
  font-family: Calibri, sans-serif !important;
  color: #00000099;
  font-size: 18px !important;
}
.dass-font-body-table {
  background-color: white;
  font-family: Calibri, sans-serif !important;
  color: #000000DE;
  font-size: 18px !important;
}

.dass-sticky-header-table {  
  height: calc(100vh - 50vh);
  resize: vertical;
  .q-table--dense .q-table thead tr, .q-table--dense .q-table tbody tr, .q-table--dense .q-table tbody td {
    width: 48px !important;
  }
  thead tr th {    
    position: sticky;
    z-index: 1;
  }
  thead tr:first-child th {
    top: 0;
  }
  &.q-table--loading thead tr:last-child th {
    top: 48px;
  }
  tbody {
    scroll-margin-top: 48px;
  }
  .dass-rotated-button {
    transform: rotate(180deg);
    transition: transform 0.3s ease-in-out;
  }
  .dass-rotated-button-back {
    transform: rotate(0deg);
    transition: transform 0.3s ease-in-out;
  }
  .dass-th-padding {
    padding: var(--space__1-5x) 0 var(--space__1-5x) 0;
  }
  @media (max-width: 700px) {
    .dass-inputs-filter-table-transactions {
      width: 100%;
    }
  }
}
</style>